import TextInput from './Input';

export default TextInput;
